var map = {
	"./Index": [
		39792,
		975,
		387,
		792
	],
	"./Index.vue": [
		39792,
		975,
		387,
		792
	],
	"./coupon/Index": [
		99784,
		975,
		387,
		728,
		925,
		784
	],
	"./coupon/Index.vue": [
		99784,
		975,
		387,
		728,
		925,
		784
	],
	"./coupon/QrcodeComponent": [
		42925,
		925
	],
	"./coupon/QrcodeComponent.vue": [
		42925,
		925
	],
	"./mobile/AllYouCanEat": [
		76573,
		975,
		387,
		728,
		573
	],
	"./mobile/AllYouCanEat.vue": [
		76573,
		975,
		387,
		728,
		573
	],
	"./mobile/BookingTable": [
		89743,
		975,
		387,
		728,
		743
	],
	"./mobile/BookingTable.vue": [
		89743,
		975,
		387,
		728,
		743
	],
	"./mobile/BuyerInfoView": [
		53489,
		975,
		387,
		728,
		489
	],
	"./mobile/BuyerInfoView.vue": [
		53489,
		975,
		387,
		728,
		489
	],
	"./mobile/CartListView": [
		94374,
		975,
		387,
		728,
		374
	],
	"./mobile/CartListView.vue": [
		94374,
		975,
		387,
		728,
		374
	],
	"./mobile/Contact": [
		20407,
		975,
		387,
		728,
		407
	],
	"./mobile/Contact.vue": [
		20407,
		975,
		387,
		728,
		407
	],
	"./mobile/CustomView": [
		22297,
		975,
		387,
		728,
		297
	],
	"./mobile/CustomView.vue": [
		22297,
		975,
		387,
		728,
		297
	],
	"./mobile/FoodListView": [
		69935,
		975,
		387,
		728,
		935
	],
	"./mobile/FoodListView.vue": [
		69935,
		975,
		387,
		728,
		935
	],
	"./mobile/IndexView": [
		46426,
		975,
		387,
		728,
		426
	],
	"./mobile/IndexView.vue": [
		46426,
		975,
		387,
		728,
		426
	],
	"./mobile/OrderDetailsView": [
		87275,
		975,
		387,
		728,
		275
	],
	"./mobile/OrderDetailsView.vue": [
		87275,
		975,
		387,
		728,
		275
	],
	"./mobile/OrderSuccessView": [
		54663,
		975,
		387,
		728,
		663
	],
	"./mobile/OrderSuccessView.vue": [
		54663,
		975,
		387,
		728,
		663
	],
	"./mobile/TimeView": [
		91429,
		975,
		387,
		728,
		429
	],
	"./mobile/TimeView.vue": [
		91429,
		975,
		387,
		728,
		429
	],
	"./pages/AllYouCanEat": [
		73913,
		975,
		257,
		13,
		913
	],
	"./pages/AllYouCanEat.vue": [
		73913,
		975,
		257,
		13,
		913
	],
	"./pages/BookingTable": [
		74484,
		975,
		387,
		257,
		13,
		484
	],
	"./pages/BookingTable.vue": [
		74484,
		975,
		387,
		257,
		13,
		484
	],
	"./pages/BuyerInfoView": [
		72921,
		975,
		387,
		257,
		13,
		921
	],
	"./pages/BuyerInfoView.vue": [
		72921,
		975,
		387,
		257,
		13,
		921
	],
	"./pages/CartListView": [
		98912,
		975,
		387,
		257,
		13,
		912
	],
	"./pages/CartListView.vue": [
		98912,
		975,
		387,
		257,
		13,
		912
	],
	"./pages/Contact": [
		40009,
		975,
		387,
		257,
		13,
		9
	],
	"./pages/Contact.vue": [
		40009,
		975,
		387,
		257,
		13,
		9
	],
	"./pages/CustomView": [
		7487,
		975,
		257,
		13,
		487
	],
	"./pages/CustomView.vue": [
		7487,
		975,
		257,
		13,
		487
	],
	"./pages/IndexView": [
		9204,
		975,
		387,
		257,
		204
	],
	"./pages/IndexView.vue": [
		9204,
		975,
		387,
		257,
		204
	],
	"./pages/Login": [
		87927,
		975,
		257,
		13,
		927
	],
	"./pages/Login.vue": [
		87927,
		975,
		257,
		13,
		927
	],
	"./pages/Register": [
		4442,
		975,
		257,
		13,
		442
	],
	"./pages/Register.vue": [
		4442,
		975,
		257,
		13,
		442
	],
	"./results/PaymentFailed": [
		48989,
		975,
		257,
		989
	],
	"./results/PaymentFailed.vue": [
		48989,
		975,
		257,
		989
	],
	"./results/PaymentSuccess": [
		21578,
		975,
		387,
		257,
		578
	],
	"./results/PaymentSuccess.vue": [
		21578,
		975,
		387,
		257,
		578
	],
	"./takeaway02/Cart": [
		70853,
		975,
		853
	],
	"./takeaway02/Cart.vue": [
		70853,
		975,
		853
	],
	"./takeaway02/Checkout": [
		87371,
		975,
		387,
		630,
		371
	],
	"./takeaway02/Checkout.vue": [
		87371,
		975,
		387,
		630,
		371
	],
	"./takeaway02/Custom": [
		76236,
		975,
		387,
		630,
		236
	],
	"./takeaway02/Custom.vue": [
		76236,
		975,
		387,
		630,
		236
	],
	"./takeaway02/Delivery": [
		62261,
		975,
		387,
		261
	],
	"./takeaway02/Delivery.vue": [
		62261,
		975,
		387,
		261
	],
	"./takeaway02/Food": [
		9379,
		975,
		387,
		379
	],
	"./takeaway02/Food.vue": [
		9379,
		975,
		387,
		379
	],
	"./takeaway02/IndexView": [
		40477,
		975,
		387,
		630,
		477
	],
	"./takeaway02/IndexView.vue": [
		40477,
		975,
		387,
		630,
		477
	],
	"./takeaway02/OrderDetial": [
		1737,
		975,
		387,
		630,
		737
	],
	"./takeaway02/OrderDetial.vue": [
		1737,
		975,
		387,
		630,
		737
	],
	"./takeaway02/Search": [
		34151,
		151
	],
	"./takeaway02/Search.vue": [
		34151,
		151
	],
	"./takeaway02/SubFood": [
		20034,
		975,
		387,
		34
	],
	"./takeaway02/SubFood.vue": [
		20034,
		975,
		387,
		34
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 26968;
module.exports = webpackAsyncContext;